import Icon from '@/components/ui/AppIcon';

interface ProcessTimelineProps {
  phases: Array<{
    number: string;
    title: string;
    duration: string;
  }>;
  activePhase: number;
  onPhaseSelect: (index: number) => void;
}

const ProcessTimeline = ({ phases, activePhase, onPhaseSelect }: ProcessTimelineProps) => {
  return (
    <div className="relative">
      <div className="hidden lg:block absolute top-8 left-0 right-0 h-0.5 bg-zinc-200">
        <div
          className="h-full bg-[#1B5E4F] transition-all duration-500"
          style={{ width: `${(activePhase / (phases.length - 1)) * 100}%` }}
        ></div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-6 gap-4 lg:gap-6">
        {phases.map((phase, index) => (
          <div key={index} className="relative">
            <button
              onClick={() => onPhaseSelect(index)}
              className={`w-full flex lg:flex-col items-center lg:items-center space-x-4 lg:space-x-0 lg:space-y-2 p-4 lg:p-0 rounded-xl lg:rounded-none transition-all duration-300 ${
                activePhase === index
                  ? 'bg-[#1B5E4F]/10 lg:bg-transparent' :'hover:bg-zinc-100 lg:hover:bg-transparent'
              }`}
            >
              <div
                className={`relative z-10 w-16 h-16 rounded-full flex items-center justify-center font-headline text-lg font-normal transition-all duration-300 ${
                  activePhase === index
                    ? 'bg-[#1B5E4F] text-white shadow-lg scale-110'
                    : activePhase > index
                    ? 'bg-[#1B5E4F]/30 text-[#1B5E4F]' :'bg-zinc-100 text-black/50'
                }`}
              >
                {activePhase > index ? (
                  <Icon name="CheckIcon" size={24} className="text-[#1B5E4F]" />
                ) : (
                  phase.number
                )}
              </div>

              <div className="flex-1 text-left lg:text-center">
                <p
                  className={`font-medium text-sm transition-colors duration-300 ${
                    activePhase === index
                      ? 'text-[#1B5E4F]' :'text-black'
                  }`}
                >
                  {phase.title}
                </p>
                <p className="text-xs text-black/50 mt-1">
                  {phase.duration}
                </p>
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessTimeline;